<template>
  <v-dialog v-model="dialog" width="800px" scrollable>

    <v-card class="pb-5" >
      <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Ajuan Mutasi</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
      <v-card-text v-if="Object.keys(detil).length">
        <v-row class="mt-2">
          <v-col class="text-center px-0" cols="12" md="3" align-end colbox>
            <v-avatar :size="120" color="grey lighten-4">
              <img :src="'img/cowok.png'" alt="avatar" />
            </v-avatar>
          </v-col>
          <v-col cols="12" md="9">
            <v-row class="black--text">
              <v-col cols="12" md="9">
                <div>
                  <b class="body-1 font-weight-bold">{{ detil && detil.users && detil.users.nama }}</b>
                  <span class="mx-4 grey--text">|</span>
                  <span :class="detil && detil.is_asal ? 'grey--text text--darken-1' : 'orange--text'">
                    {{ detil && detil.is_asal ? 'Mutasi Keluar' : 'Mutasi Masuk' }}
                  </span>
                </div>
                <div class="body-2 mt-1">
                  NIP.
                  {{
                    detil && detil.users && detil.users.no_pegawai
                      ? detil && detil.users && detil.users.no_pegawai
                      : 'Belum ada'
                  }}
                </div>

              </v-col>
              <v-col v-if="!isTenant" cols="12" md="3">
                <v-chip :color="mStatus[detil.k_status]['color']" outlined small>
                  {{  detil && detil.is_ajuan_tenant === 1 ? 'Tenant' : mStatus[detil.k_status]['text'] }}
                </v-chip>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                 <v-divider class="mb-5"></v-divider>
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <div class="grey--text caption">Organisasi Asal</div>
                    <div class="black--text">
                      <b>{{ (detil && detil.organisasi_asal && detil.organisasi_asal.nama) || '' }}</b>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <div class="grey--text caption">Organisasi Tujuan</div>
                    <div class="black--text">
                      <b>{{ (detil && detil.organisasi_tujuan && detil.organisasi_tujuan.nama) || '' }}</b>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <div class="grey--text caption">Tanggal Mutasi (aktif di organisasi tujuan)</div>
                    <div class="black--text"> {{ detil.tgl_mutasi | toSDN }}</div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <div class="grey--text caption">Tanggal Awal (riwayat presensi ditarik)</div>
                    <div class="black--text"> {{ detil.tgl_mulai | toSDN }} </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <div class="grey--text caption">Dokumen Mutasi</div>
                    <div class="black--text">
                      {{ (detil && detil.file) || 'Tidak ditambahkan' }}
                      <v-btn v-if="detil.url_file" small depressed color="primary" @click="toLink">
                        <v-icon left>mdi-eye</v-icon> Lihat Dokumen
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="grey lighten-4">
                    <div class="grey--text caption">Keterangan</div>
                    <div class="black--text">
                      {{ detil.keterangan || '-' }}
                    </div>
                    <div>
                      Oleh: <b>{{ (detil && detil.users_ajuan && detil.users_ajuan.nama) || '' }}</b>
                    </div>
                  </v-col>

                  <v-col v-if="!canKonfimasi && [5, 6].includes(detil.k_status)" cols="12" md="12" sm="12" class="px-0 pt-5">
                    <v-alert text v-if="detil.k_status === 5" icon="mdi-information" type="info" class="body-2">
                      <span class="font-weight-medium">Informasi Disetujui</span><br />
                      {{ detil && detil.alasan }}
                    </v-alert>
                    <v-alert v-else text icon="mdi-information" type="red" class="body-2">
                      <span class="font-weight-medium">Informasi Ditolak</span><br />
                      {{ detil && detil.alasan }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-card-text>
      <div v-if="canKonfimasi" class="text-right mr-2">
        <v-divider class="my-5"></v-divider>

        <v-btn dark depressed color="success" @click="onKonfirmasi(5)">
          <v-icon left>mdi-check</v-icon>
          Setuju
        </v-btn>
        <v-btn class="mx-1" dark depressed color="red" @click="onKonfirmasi(6)">
          <v-icon left>mdi-close</v-icon>
          Tolak
        </v-btn>
      </div>
      <div v-if="canBatalAjuan" class="text-right mr-2">
        <v-divider class="my-5"></v-divider>
        <v-btn class="mx-1" dark depressed color="red" @click="onBatalAjuan">
          <v-icon left>mdi-close</v-icon>
          Batal Ajuan
        </v-btn>
      </div>
    </v-card>

    <v-dialog v-model="konfirmasi.dialog" width="700px">
      <v-toolbar dark flat :color="konfirmasi.color">
        <v-toolbar-title>{{ konfirmasi.label }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="konfirmasi.dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-card-text>
          <div class="my-2">
            Apakah Anda yakin akan melakukan mutasi pada <b>{{ detil && detil.users && detil.users.nama }}</b>
          </div>
          <v-textarea
            v-model="alasan"
            :label="`Silakan Masuk asalan Anda ${konfirmasi.label}`"
            outlined
            single-line
          ></v-textarea>
        </v-card-text>
        <div class="text-right mr-2">
          <v-btn dark depressed color="success" @click="saveKonfirmasi(konfirmasi.status)">
            <v-icon left>mdi-check</v-icon>
            Ya
          </v-btn>
          <v-btn class="mx-1" dark depressed color="red" @click="konfirmasi.dialog = false">
            <v-icon left>mdi-close</v-icon>
            Batal
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { M_STATUS, M_KONFIRMASI } from '@/modules/mutasi/const'

export default {
  props: {
    isTenant: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dialog: false,
      detil: {},
      mStatus: M_STATUS,
      alasan: '',
      konfirmasi: {
        status: 4,
        color: 'success',
        label: 'Setujui Mutasi',
        dialog: false,
      },
    }
  },

  computed: {
    canKonfimasi() {
      if (this.isTenant) {
        return this.detil && this.detil.k_status === 4 && !this.detil.is_asal
      } else {
        return this.detil && this.detil.k_status === 4 && this.isCan('mutasi.konfirmasi') && !this.detil.is_asal
      }
    },

    canBatalAjuan() {
      if (this.isTenant) {
        return this.detil && this.detil.k_status === 4 && this.detil.is_asal
      } else {
        return this.detil && this.detil.k_status === 4 && this.isCan('mutasi.batal') && this.detil.is_asal
      }
    }
  },

  methods: {
    open(obj) {
      this.detil = obj
      this.dialog = true
    },

    onKonfirmasi(status) {
      this.konfirmasi.label = M_KONFIRMASI[status]['label']
      this.konfirmasi.color = M_KONFIRMASI[status]['color']
      this.konfirmasi.status = status
      this.alasan = ''
      this.konfirmasi.dialog = true
    },

    saveKonfirmasi(status) {
      if (!this.alasan) {
        this.$error('Harap isikan catatan')
        return
      }

      this.$store
        .dispatch('mutasi/updateTenant', {
          id: this.detil && this.detil.mutasi_id,
          no_reg: this.current_user.kode_tenant,
          params: {
            k_status: status,
            alasan: this.alasan,
          },
        })
        .then(() => {
          this.$success('Aksi berhasil dijalankan')
          this.dialog = false
          this.$emit('refresh')
        })
    },

    toLink() {
      window.open(this.detil.url_file, '_blank')
    },

    onBatalAjuan() {
      this.$confirmDanger(`
        <div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">
            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>
            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

         Apakah Anda yakin akan membatalkan ajuan mutasi berikut ini ?<br>
      `).then(() => {
        this.$store
          .dispatch('mutasi/batalTenant', {
            id: this.detil && this.detil.mutasi_id,
            no_reg: this.current_user.kode_tenant,
          })
          .then(() => {
            this.$success('Aksi berhasil dijalankan')
            this.dialog = false
            this.$emit('refresh')
          })
      })
    }
  },
}
</script>
